export const PLAIN_SUBPROTOCOL = 'wis';

export const AUTHENTICATED_SUBPROTOCOL = 'wis.session';

export const TOKEN_SUBPROTOCOL_PREFIX = 'wis.token.';

/** Matches the server's own bound (`SessionSubprotocol.MaxTokenChars`). */
export const MAX_TOKEN_CHARS = 4096;

/** Header-injection guard, checked before the token is ever interpolated into the subprotocol list: a token with a space, comma, newline or control character is refused rather than relying on the runtime throwing. */
export function isOfferableToken(token: string): boolean {
  if (token.length === 0 || token.length > MAX_TOKEN_CHARS) return false;
  return /^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/.test(token);
}

export function offeredSubprotocols(token: string | null): string[] {
  if (token === null || !isOfferableToken(token)) return [PLAIN_SUBPROTOCOL];
  return [AUTHENTICATED_SUBPROTOCOL, PLAIN_SUBPROTOCOL, `${TOKEN_SUBPROTOCOL_PREFIX}${token}`];
}

/** Strict equality, deliberately: a looser compare would make "authenticated" a thing the client decides, and the client is the party that does not know. */
export function isAuthenticatedSubprotocol(selected: string | null | undefined): boolean {
  return selected === AUTHENTICATED_SUBPROTOCOL;
}
